import { ChangeEvent, useState } from 'react'

import { FieldError } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import CameraIcon from 'shared/icons/camera_icon.svg'
import SmallCrossIcon from 'shared/icons/close_small_icon.svg'

import styles from './styles.module.scss'

interface Props {
  name?: string
  files?: File[]
  error?: FieldError
  onLoadFiles: (data: File[] | undefined) => void
}

const COUNT_IMAGES = 3

const UploadFile = ({ onLoadFiles, files, error, name }: Props) => {
  const { t } = useTranslation()

  const [uploadsFiles, setUploadFiles] = useState<File[] | null>(files || null)

  const onLoadFile = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]

    if (!file) return

    const uploadedFiles = uploadsFiles?.length
      ? [...uploadsFiles, file]
      : [file]

    if (uploadsFiles !== null) {
      setUploadFiles((data) => [...data!, file])
    } else {
      setUploadFiles([file])
    }

    onLoadFiles?.(uploadedFiles)
  }

  const onRemoveImage = (index: number) => {
    const newFiles = uploadsFiles?.filter((_, ind) => ind !== index)

    setUploadFiles(newFiles || null)

    onLoadFiles?.(newFiles)
  }

  const filesUrls = uploadsFiles?.map((item) => URL.createObjectURL(item)) || []

  return (
    <div className={clsx(styles.container, error && styles.errorField)}>
      <p>{t('feed_back.attach_photo')}</p>
      <span>{t('feed_back.attach_photo_des')}</span>

      {!(files?.length || 0) && (
        <label
          htmlFor={name || 'fileLoad'}
          className={styles.label}
        >
          <div className={styles.buttonWrapper}>
            <img
              src={CameraIcon}
              alt=""
            />
            <p className={styles.btnName}>{t('feed_back.add_photo')}</p>
          </div>
        </label>
      )}

      {files && files?.length > 0 ? (
        <div className={styles.images}>
          {filesUrls?.length < COUNT_IMAGES ? (
            <label
              htmlFor={name || 'fileLoad'}
              className={styles.labelSingle}
            >
              <img
                src={CameraIcon}
                alt=""
              />
            </label>
          ) : null}

          {filesUrls?.map((file, index) => (
            <div
              className={styles.item}
              key={'img_' + index}
            >
              <img
                src={file}
                alt=""
              />

              <span
                className={styles.close}
                onClick={() => onRemoveImage(index)}
              >
                <img
                  src={SmallCrossIcon}
                  alt=""
                />
              </span>
            </div>
          ))}
        </div>
      ) : null}
      <input
        type="file"
        id={name || 'fileLoad'}
        className={styles.input}
        onChange={onLoadFile}
        accept="image/*"
        key={filesUrls?.length || 'none'}
      />
    </div>
  )
}

export default UploadFile
